import { BusinessSignals, searchParamsSignal } from "@/apis/api_signals"
import BottomNavigateBar from "@/components/composite/BottomNavigateBar"
import ModalSlideUp from "@/components/composite/ModalSlideUp/main"
import { PATHS } from "@/constants/path"
import AppSignals from "@/features_signal/app"
import kycController from "@/features_signal/kyc/kycController"
import { createLogger } from "@/utils/logger"
import { setLocation, setNavigate, setSetSearchParams } from "@/utils/navigation"
import styled from "@emotion/styled"
import { useEffect, useRef } from "preact/compat"
import { useLocation, useMatch, useNavigate, useSearchParams } from "react-router-dom"
import { AnimatedLayoutWithOutletPattern } from "./AnimatedLayout"
import SearchActionLayout from "./SearchActionLayout"
import WebpAnimation, { type WebpAnimationHandle } from "@/components/composite/WebpAnimation/main"
import { useSignal } from "@preact/signals"
import { css } from "@emotion/react"
import BlindBoxModal from "@/pages/BlindBox/modal"

const logger = createLogger("RouterRootLayout")

const Root = styled.div`
    align-self: stretch;
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
`

function RootInnerRouterSideEffects() {
    const navigate = useNavigate()
    const location = useLocation()
    const [_, setSearchParams] = useSearchParams()

    useEffect(() => {
        searchParamsSignal.value = new URLSearchParams(location.search)
        logger.info("location", location)
    }, [location])

    useEffect(() => {
        searchParamsSignal.value = new URLSearchParams(location.search)
        setNavigate(navigate)
        setLocation(location)
        setSetSearchParams(setSearchParams)
    }, [navigate, location, setSearchParams])

    return null
}

function KycRedirectHandler() {
    logger.debug("KycRedirectHandler Render")
    const matchKyc = useMatch(PATHS.KYC)
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        try {
            if (
                !matchKyc &&
                AppSignals.isKycRouterCheckerActive.value &&
                BusinessSignals.isUserLogin.value &&
                BusinessSignals.hoursAfterMemberCreated72Hours.value &&
                BusinessSignals.kycSourceData.value.kyc.status !== "fully_kyc"
            ) {
                logger.info("KYC verification required, redirecting...", {
                    isUserLogin: BusinessSignals.isUserLogin.value,
                    notApprovedOver72Hours: kycController.notApprovedOver72Hours.value,
                    currentPath: location.pathname,
                })

                // 可以添加一些過渡效果或提示
                navigate(PATHS.KYC, { replace: true })
            }
        } catch (error) {
            logger.debug("Error during KYC redirect:", error)
        }
    }, [matchKyc, navigate, location])

    return null
}

function RouterRootLayout() {
    return (
        <Root>
            {/* <KycRedirectHandler /> */}
            <RootInnerRouterSideEffects />
            <AnimatedLayoutWithOutletPattern />
            <ModalSlideUp
                familyName="kyc-warning-with-countdown"
                priority={10}
            />
            <ModalSlideUp
                familyName="root"
                priority={0}
            />
            <ModalSlideUp
                familyName="pagcor"
                priority={100}
            />
            <ModalSlideUp
                familyName="kyc-status-modal"
                priority={200}
            />
            <SearchActionLayout />
            <BlindBoxModal />
            <BottomNavigateBar />
        </Root>
    )
}

export default RouterRootLayout
